import {
  Breadcrumb,
  Button,
  Card,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ReactComponent as TitleIcon } from "../../assests/images/settingsBreadCum.svg";
import { ReactComponent as DebitCardIcon } from "../../assests/images/requestDebitCard.svg";
import AccountCard from "../../components/account-card";
import { useCallback, useState } from "react";
import CommonOtp from "../../components/otp";
import AccountSelectedCard from "../../components/account-selected-card";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import { useEffect } from "react";
import RequestService from "../../services/request.service";
import AccountDisplay from "../../components/account-display";
import { selectedAccountSelector } from "../../store/selectors/app.selector";
import { useSelector } from "react-redux";

export default function RequestDebitCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [stage, setStage] = useState(1);
  const [otp, setOtp] = useState("");
  const [form] = Form.useForm();
  const [cardProduct, setCardProduct] = useState([]);
  const selectedAccount = useSelector(selectedAccountSelector);
  const [successVisible, setSuccessVisible] = useState(false);
  const [formDetails, setFormDetails] = useState({});
  const [completedDetails, setCompletedDetails] = useState({});

  useEffect(() => {
    getAllCardProducts();
  }, []);

  const getAllCardProducts = useCallback(async () => {
    try {
      const response = await RequestService.getAllCardProducts();
      if (response.status === 200) {
        setCardProduct(response.data["data"]["cardProductList"]);
      }
    } catch (error) {}
  }, []);

  const onVerify = useCallback(
    async (values) => {
      try {
        console.log("values", values);
        const req = {
          cardProduct: values.cardProduct,
          address: "",
          addressType: "",
          cardHoldersName: selectedAccount.accountName,
          accountNo: selectedAccount.accountNo,
        };
        setFormDetails(req);
        const response = await RequestService.debitCardRequestVerify(req);
        if (response.status === 200) {
          setStage(2);
        }
      } catch (error) {}
    },
    [selectedAccount]
  );

  const onConfirm = useCallback(async (values) => {
    try {
      const response = await RequestService.debitCardRequestConfirm(values);
      if (response.status === 200) {
        setCompletedDetails(response.data);
        setSuccessVisible(true);
      }
    } catch (error) {
      setOtp("");
    }
  }, []);

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) => onConfirm({ ...formDetails, ...values })}
            handleResendOtp={() => onVerify(formDetails)}
            cancelTransaction={() => {
              navigate("/card-settings");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <>
        <div className="row">
          <div className="d-flex align-items-center">
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4">
              <AccountDisplay type="image" />
            </div>
          </div>
        </div>
        <Form
          layout="vertical"
          onFinish={onVerify}
          requiredMark={true}
          form={form}
        >
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Form.Item
                name={"cardProduct"}
                label={t("pages.card_settings.card_product", {
                  defaultValue: "Card Product",
                })}
                rules={[
                  {
                    required: true,
                    message: t("pages.card_settings.card_product_req", {
                      defaultValue: "Card Product is required",
                    }),
                  },
                ]}
              >
                <Select
                  placeholder={t("pages.card_settings.card_product", {
                    defaultValue: "Card Product",
                  })}
                  bordered={true}
                  optionFilterProp="children"
                  showSearch
                  size="large"
                >
                  {cardProduct.map((option, idx) => (
                    <Select.Option key={idx} value={option?.cardProductCode}>
                      {option?.cardProductName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
          </div>
          <div className="d-flex justify-content-end  mt-3">
            <Button
              onClick={() => navigate("/card-settings")}
              type="default"
              style={{ marginRight: 20 }}
              className="secondary-btn"
              size="large"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button
              type="primary"
              className="primary-btn"
              htmlType="submit"
              size="large"
            >
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>
          </div>
        </Form>
      </>
    );
  }

  return (
    <>
      <Breadcrumb separator=">">
        {/* <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14} />
          </span>
        </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/card-settings")}>
            {t("pages.profile.debit_card", {
              defaultValue: "Debit Card",
            })}
          </span>
        </Breadcrumb.Item>

        <Breadcrumb.Item>
          <span>
            {t("pages.card_settings.new_debit_card_request", {
              defaultValue: "New Debit Card Request",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {" "}
              {t("pages.card_settings.request_debit_card", {
                defaultValue: "Request Debit Card",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="row d-flex justify-content-between">
          {stage === 1 ? (
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
              <Card className="application-card">
                <AccountCard />
              </Card>
            </div>
          ) : (
            <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4 col-xl-4 hide-xs">
              <Card className="application-card">
                <AccountSelectedCard />
              </Card>
            </div>
          )}
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
            <Card className="payee-render-section application-card">
              {renderSwitch()}
            </Card>
          </div>
        </div>
      </div>
      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{completedDetails.message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/card-settings");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}
